// extracted by mini-css-extract-plugin
export default {"text_button":"TextButton_text_button__el+5g","btn_inner":"TextButton_btn_inner__gH6I+","label":"TextButton_label__6Wjj+","disabled":"TextButton_disabled__pOf8g"};